"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Img = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Img = exports.Img = (0, _mui.styled)('img', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isPlaceholderVisible
}) => ({
  visibility: isPlaceholderVisible ? 'hidden' : 'visible'
}));
